'use client'

import type React from 'react'
import { useEffect } from 'react'

import { useSession } from './use-session'

interface AuthGuardProps {
  redirectUrl?: string
}

export const AuthGuard: React.FC<AuthGuardProps> = ({
  redirectUrl = '/error?issue=unauthorized',
}: AuthGuardProps) => {
  const { data: session, isLoading } = useSession()

  useEffect(() => {
    if (!isLoading && !session) {
      window.location.href = redirectUrl
    }
  }, [session, isLoading])

  return null
}
